import React from 'react';
import { AppContext } from '../state/app-state';

export const useUserData = () => {
    const context = React.useContext(AppContext);
    if (context === undefined) throw new Error('useUserData must me used within the AppState provider');
    return context.userData;
};
